(function () {
  if (window.LVCReviewClient) return;
  const endpoint = 'https://lvc-reviews.onrender.com/api/products/reviews';
  const responses = new Map();
  const identities = new Map();

  function publicName(value) {
    const name = String(value || '').trim().replace(/\s+/g, ' ');
    if (!name || name.includes('@') || /\d{5,}/.test(name)) return 'Cliente';
    const parts=name.split(' ');
    const first=parts.shift();
    const given=first.includes('.')?first:first===first.toUpperCase()?first.charAt(0).toUpperCase()+first.slice(1).toLocaleLowerCase('es'):first.charAt(0).toUpperCase()+first.slice(1);
    return given+(parts.length?' '+parts.map(part=>part.charAt(0).toUpperCase()+'.').join(' '):'');
  }

  function milestoneLabel(total) {
    const n = Number(total);
    if (!Number.isFinite(n) || n < 1) return 'Opiniones de clientes';
    const actual = Math.floor(n);
    const milestone = actual >= 100 ? Math.floor(actual / 100) * 100 : actual;
    return (actual > milestone ? 'Más de ' : '') + new Intl.NumberFormat('es-ES').format(milestone) + (milestone === 1 ? ' opinión' : ' opiniones');
  }

  function displayName(review) {
    if (review?.review_origin === 'google' || review?.review_source === 'google-business') return 'Valoración en Google';
    const chosen=String(review?.public_display_name || '').trim().replace(/\s+/g,' ');
    if(chosen)return chosen.includes('@') || /\d{5,}/.test(chosen)?'Cliente':chosen;
    return publicName(review?.reviewer_name || review?.customer_name);
  }

  function urlFor(scope, options = {}) {
    const params = new URLSearchParams(scope);
    params.set('limit', String(options.limit || 200));
    params.set('page', String(options.page || 1));
    params.set('filter', options.filter || 'all');
    params.set('sort', options.sort || 'recent');
    return endpoint + '?' + params;
  }

  async function response(scope, options) {
    const url = urlFor(scope, options);
    if (!responses.has(url)) {
      const pending = fetch(url, {cache: 'no-store'}).then(result => {
        if (!result.ok) throw new Error('reviews_unavailable');
        return result;
      });
      responses.set(url, pending);
      pending.catch(() => responses.delete(url));
    }
    return (await responses.get(url)).clone();
  }

  async function resolveIdentity(product) {
    const key = JSON.stringify([product.id || '', product.handle || '', product.title || '']);
    if (!identities.has(key)) {
      const pending = (async () => {
        const scopes = [];
        if (product.id) scopes.push({id: String(product.id).replace(/^gid:\/\/shopify\/Product\//, '')});
        if (product.handle && product.title) scopes.push({handle: product.handle, title: product.title});
        if (!scopes.length) throw new Error('missing_verified_product_identity');
        const results = await Promise.allSettled(scopes.map(async scope => {
          const result = await (await response(scope, {limit: 3})).json();
          const total = Number(result.summary?.total);
          if (!result.ok || !Number.isSafeInteger(total) || total < 0) throw new Error('invalid_reviews');
          return {scope, total};
        }));
        const valid = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        if (!valid.length) throw new Error('reviews_unavailable');
        valid.sort((a, b) => b.total - a.total);
        return valid[0].scope;
      })();
      identities.set(key, pending);
      pending.catch(() => identities.delete(key));
    }
    return identities.get(key);
  }

  function readJson(root, selector) {
    try {
      let value = JSON.parse(root.querySelector(selector)?.textContent || 'null');
      if (typeof value === 'string') { try { value = JSON.parse(value); } catch (_) {} }
      return value;
    } catch (_) { return null; }
  }

  function savedReviews(product, options = {}) {
    const id = String(product.id || '').replace(/^gid:\/\/shopify\/Product\//, '');
    const root = Array.from(document.querySelectorAll('[data-lvc-reviews]')).find(element =>
      id ? element.getAttribute('data-product-id') === id :
        product.handle && element.getAttribute('data-handle') === product.handle
    );
    if (!root) return null;
    const seed = readJson(root, '[data-lvc-seed]') || {};
    if (String(seed.product_external_id || id) !== id) return null;
    const total = Number(seed.number_of_reviews || 0);
    const average = Number(seed.average_rating || 0);
    if (!Number.isSafeInteger(total) || total < 1 || !Number.isFinite(average) || average < 1 || average > 5) return null;
    const byId = new Map();
    const add = review => {
      if (!Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5) return;
      const key = review.id || JSON.stringify([review.customer_name, review.created_at, review.body]);
      if (!byId.has(key)) byId.set(key, review);
    };
    for (const item of seed.reviews || []) {
      const media = [];
      for (const picture of item.pictures_urls || []) {
        const url = picture && (picture.huge || picture.original || picture.small);
        if (url) media.push({url, type: 'image'});
      }
      for (const video of item.media_platform_hosted_video_infos || []) {
        const url = video && (video.url || video.video_url);
        if (url) media.push({url, type: 'video'});
      }
      const fitValue = (item.cf_answers || []).map(answer => answer.value || '').join(' ').toLowerCase();
      add({
        id: item.uuid || '', customer_name: item.reviewer_name || 'Cliente',
        verified: item.verified_buyer === true || item.verified_buyer === 'true',
        rating: Number(item.rating), body: item.body || '', created_at: item.created_at,
        fit: /correct/.test(fitValue) ? 'normal' : /peque/.test(fitValue) ? 'small' : /grand/.test(fitValue) ? 'large' : null,
        media, merchant_reply: item.reply_content || ''
      });
    }
    const raw = readJson(root, '[data-lvc-ssr]');
    if (typeof raw === 'string') {
      const doc = new DOMParser().parseFromString(raw, 'text/html');
      for (const item of doc.querySelectorAll('.jdgm-rev')) {
        const media = [];
        for (const picture of item.querySelectorAll('.jdgm-rev__pic-link')) {
          const url = picture.getAttribute('data-mfp-src') || picture.getAttribute('href');
          if (url) media.push({url, type: 'image'});
        }
        for (const video of item.querySelectorAll('.jdgm-rev__vids video,.jdgm-rev__vids source')) {
          const url = video.getAttribute('src');
          if (url) media.push({url, type: 'video'});
        }
        const fitValue = (item.querySelector('.jdgm-rev__cf-ans__value')?.textContent || '').toLowerCase();
        add({
          id: item.getAttribute('data-review-id') || '',
          customer_name: item.querySelector('.jdgm-rev__author')?.textContent || 'Cliente',
          verified: item.getAttribute('data-verified-buyer') === 'true',
          rating: Number(item.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')),
          body: item.querySelector('.jdgm-rev__body')?.textContent || '',
          created_at: item.querySelector('time')?.getAttribute('datetime') || '',
          fit: /correct/.test(fitValue) ? 'normal' : /peque/.test(fitValue) ? 'small' : /grand/.test(fitValue) ? 'large' : null,
          media, merchant_reply: item.querySelector('.jdgm-rev__reply')?.textContent?.trim() || ''
        });
      }
    }
    let rows = Array.from(byId.values());
    const summary = {total, avg_rating: average, five: 0, four: 0, three: 0, two: 0, one: 0,
      verified: 0, small: 0, normal: 0, large: 0, with_media: 0};
    const ratings = {5: 'five', 4: 'four', 3: 'three', 2: 'two', 1: 'one'};
    for (const bin of seed.histogram || []) {
      if (ratings[bin.rating]) summary[ratings[bin.rating]] = Number(bin.frequency || 0);
    }
    for (const review of rows) {
      if (review.verified) summary.verified++;
      if (review.fit) summary[review.fit]++;
      if (review.media.length) summary.with_media++;
    }
    const filter = options.filter || 'all';
    if (/^[1-5]$/.test(filter)) rows = rows.filter(review => review.rating === Number(filter));
    else if (filter === 'verified') rows = rows.filter(review => review.verified);
    else if (filter === 'photo') rows = rows.filter(review => review.media.some(item => item.type === 'image'));
    else if (filter === 'video') rows = rows.filter(review => review.media.some(item => item.type === 'video'));
    else if (filter === 'reply') rows = rows.filter(review => review.merchant_reply);
    rows.sort((a, b) => {
      const delta = (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0);
      if (options.sort === 'old') return -delta;
      if (options.sort === 'best') return b.rating - a.rating || delta;
      if (options.sort === 'worst') return a.rating - b.rating || delta;
      return delta;
    });
    const limit = Math.max(1, Math.min(200, Number(options.limit) || 200));
    const page = Math.max(1, Number(options.page) || 1);
    return {ok: true, summary, filtered_total: rows.length, page, limit,
      reviews: rows.slice((page - 1) * limit, page * limit)};
  }

  async function fetchReviews(product, options = {}) {
    const saved = savedReviews(product, options);
    let timer;
    try {
      const remote = await Promise.race([
        resolveIdentity(product).then(scope => response(scope, options)),
        new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('reviews_timeout')), 5000); })
      ]);
      const data = await remote.clone().json();
      if (!data.ok || !Number.isFinite(Number(data.summary?.total))) throw new Error('invalid_reviews');
      if (Number(data.summary.total) > 0 || !saved) return remote;
    } catch (error) {
      if (!saved) throw error;
    } finally { clearTimeout(timer); }
    return new Response(JSON.stringify(saved), {headers: {'Content-Type': 'application/json'}});
  }


  const fitStates = new WeakMap();
  const fitObserved = new WeakSet();

  function updateProductFit(root, summary) {
    if (!root) return;
    fitStates.set(root, summary);
    const picker = root.querySelector('[data-lvc-size-option]');
    if (!picker) return;
    const counts = ['small', 'normal', 'large'].map(key => Number(summary?.[key] || 0));
    const total = counts.reduce((sum, n) => sum + n, 0);
    let card = picker.querySelector('.lvc-fit-summary');
    if (!counts.every(n => Number.isSafeInteger(n) && n >= 0) || total < 1) {
      if (card) card.remove();
      return;
    }
    if (!document.getElementById('lvc-fit-summary-style')) {
      const style = document.createElement('style');
      style.id = 'lvc-fit-summary-style';
      style.textContent = '.lvc-fit-summary{display:block;margin:10px 0 4px;padding:10px 12px;border:1px solid #dce4ef;border-radius:9px;background:#f7f9fc;color:#0b2355;text-decoration:none;font-size:12px;line-height:1.4}.lvc-fit-summary:hover{border-color:#0b2355;color:#0b2355}.lvc-fit-summary__head{display:flex;justify-content:space-between;gap:8px;margin-bottom:7px}.lvc-fit-summary__head small{font-size:11px;color:#59687d}.lvc-fit-summary__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}.lvc-fit-summary__cell{display:grid;gap:4px}.lvc-fit-summary__cell b{font-size:12px;font-weight:500}.lvc-fit-summary__track{height:4px;border-radius:5px;background:#e3e8f0;overflow:hidden}.lvc-fit-summary__fill{display:block;height:100%;background:#ff5722}.lvc-fit-summary:focus-visible{outline:2px solid #ff5722;outline-offset:3px}';
      document.head.append(style);
    }
    if (!card) {
      card = document.createElement('a');
      card.className = 'lvc-fit-summary';
      card.href = '#lvc-reviews';
      picker.append(card);
    }
    const labels = ['Pequeña', 'Correcta', 'Grande'];
    const sample = total + (total === 1 ? ' respuesta' : ' respuestas');
    const cells = counts.map((n, index) => {
      const percent = Math.round(n * 100 / total);
      return '<span class="lvc-fit-summary__cell"><b>' + labels[index] + ' ' + percent + '%</b><span class="lvc-fit-summary__track"><span class="lvc-fit-summary__fill" style="width:' + percent + '%"></span></span></span>';
    }).join('');
    const html = '<span class="lvc-fit-summary__head"><strong>¿Cómo talla?</strong><small>Según ' + sample + '</small></span><span class="lvc-fit-summary__grid">' + cells + '</span>';
    if (card.innerHTML !== html) card.innerHTML = html;
    card.setAttribute('aria-label', 'Opiniones sobre la talla. ' + sample + '. ' + counts.map((n, i) => labels[i] + ': ' + n).join('. ') + '. Ver valoraciones');
    if (!fitObserved.has(root)) {
      fitObserved.add(root);
      new MutationObserver(() => {
        if (!root.querySelector('[data-lvc-size-option] .lvc-fit-summary')) updateProductFit(root, fitStates.get(root));
      }).observe(root, {childList: true, subtree: true});
    }
  }

  function updateBadge(element, summary) {
    if (!element) return;
    updateProductFit(element.closest('[id^="ProductInfo-"]'), summary);
    const total = Number(summary?.total || 0);
    const average = Number(summary?.avg_rating || 0);
    if (!Number.isFinite(total) || !Number.isFinite(average) || total < 1 || average < 1) {
      element.style.display = 'none';
      return;
    }
    element.querySelector('.lvc-reviews-badge__score').textContent = average.toFixed(1).replace('.', ',');
    element.querySelector('.lvc-reviews-badge__text').textContent = total + (total === 1 ? ' valoración' : ' valoraciones');
    element.style.display = 'block';
  }

  window.LVCReviewClient = {publicName, displayName, milestoneLabel, fetchReviews, updateBadge};
  document.dispatchEvent(new Event('lvc:reviews-ready'));
})();


